var _style, _ellipse, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDbIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 108 107",
    style: {
      enableBackground: "new 0 0 108 107"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.27;fill:#FFFFFF;enable-background:new    ;}\n\t.st1{fill:#FFFFFF;}\n")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_30",
    className: "st0",
    cx: 54,
    cy: 53.5,
    rx: 54,
    ry: 53.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-shield",
    className: "st1",
    d: "M77.6,54.7l-9-3.5c-0.6-0.2-1.2-0.2-1.7,0l-9,3.5c-0.8,0.3-1.4,1.1-1.4,1.9 c0,8.7,5.4,14.7,10.4,16.7c0.6,0.2,1.2,0.2,1.7,0c4-1.6,10.4-7,10.4-16.7C79,55.8,78.4,55,77.6,54.7z M67.7,69.6V54.8l7.5,2.9 C75,62.8,72.2,67.3,67.7,69.6z M46.5,53.5c5.5,0,10-4.5,10-10s-4.5-10-10-10s-10,4.5-10,10S41,53.5,46.5,53.5z M54,56.6 c0-0.2,0-0.4,0.1-0.6c-0.2,0-0.4-0.1-0.6-0.1h-1.3c-3.6,1.7-7.8,1.7-11.4,0h-1.3C33.7,56,29,60.7,29,66.5c0,0,0,0,0,0v3.2 c0,2.1,1.7,3.7,3.8,3.8h27.5c0.5,0,1-0.1,1.5-0.3C56.8,69.1,53.9,63,54,56.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDbIcon3);
export default __webpack_public_path__ + "static/media/db-icon-3.c0d57d80f2678fbc8a4eca2f2a6b443f.svg";
export { ForwardRef as ReactComponent };